import { AuthRepository } from "../../../../data/repository/auth/AuthRepository";
import { AccessToken, LoginAnonymouslyRequestModel } from "../../../model/Auth";
import { ResponseState, State } from "../../../model/ResponseState";

export interface LoginAnonymouslyUseCase {
  invoke: (
    body: LoginAnonymouslyRequestModel,
  ) => Promise<ResponseState<AccessToken>>;
}

export class LoginAnonymouslyUseCaseImpl implements LoginAnonymouslyUseCase {
  private authRepository: AuthRepository;

  constructor(authRepository: AuthRepository) {
    this.authRepository = authRepository;
  }

  async invoke(
    body: LoginAnonymouslyRequestModel,
  ): Promise<ResponseState<AccessToken>> {
    try {
      let response = await this.authRepository.loginAnonymously(body);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
